import { z } from "zod";

// Search values go through JSON.parse (see router-root), so a URL written
// outside the router — pasted, hand-edited, linked from PHP — turns `?q=123`
// into a number and `?q=true` into a boolean. Accept them back as strings.
export function searchString(): z.ZodPipe<
  z.ZodUnion<readonly [z.ZodString, z.ZodNumber, z.ZodBoolean]>,
  z.ZodTransform<string, string | number | boolean>
> {
  return z.union([z.string(), z.number(), z.boolean()]).transform(String);
}
